//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { truncate } from 'lodash'
import { trim } from 'lodash/string'
import sanitizeHtml from 'sanitize-html'
import ImageDisplay from '~/components/ui/ImageDisplay'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ShortPost',
  components: {
    ImageDisplay
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imageOptions: {
        resize: {
          width: 300,
          height: 200
        }
      }
    }
  },
  computed: {
    text () {
      return trim(truncate(sanitizeHtml(this.post.text.replace(/>/g, '> '), {
        allowedTags: []
      }), {
        length: 300,
        separator: ' ',
        omission: '[...]'
      })).replace(/\s\s+/g, ' ')
    }
  }
}
